import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export const useParamId = (path?: string): string => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id && path !== undefined) {
      navigate(path ?? "", { replace: true });
    }
  }, [id, undefined]);

  return id ?? "";
};
export const useContractParamIds = (path?: string) => {
  const { contractId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!contractId) {
      navigate(path ?? "", { replace: true });
    }
  }, [contractId, undefined]);

  return contractId ?? "";
};
export const useCustomParamId = (paramName: string, path?: string) => {
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!params[paramName]) {
      navigate(path ?? "", { replace: true });
    }
  }, [params[paramName], undefined]);

  return params[paramName] ?? "";
};
